<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>조황정보</h3>
                            <div class="h6 mt-4">
                                현아호와 함께하는 선상낚시에서는 최상의 물고기를 보장합니다! 최상의 낚시 경험을 누려보세요.
                            </div>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div class="row justify-content-center">
                                <div class="row col-lg-12" style="display: flex;">
                                    <div class="col-lg-6 card-div overflow-hidden">
                                        <img src="img/theme/gallery-1.png" width="100%">
                                    </div>
                                    <div class="col-lg-6 card-div">
                                        <div>
                                            <p>
                                                &nbsp;&nbsp;선상낚시의 진정한 매력을 경험하세요! 
                                                <br><br>태안현아호만의 비밀 낚시 포인트에서는 언제나 최상급 어종이 기다립니다.
                                                <br><br>&nbsp;&nbsp;손 맛이 끝내주는 행운을 만끽하며, 싱싱한 물고기를 직접 잡아보세요. 
                                                <br><br>&nbsp;&nbsp;언제나 신선하고 품질 높은 물고기가 보장됩니다. 
                                                &nbsp;&nbsp;태안현아호와 함께 오늘 낚시의 새로운 차원을 경험하세요!
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="row justify-content-center">
                                <div class="row col-lg-12 p-0" style="display: flex;">
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish1.jpg" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish2.jpg" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish3.jpg" width="100%" style="min-height: 250px;">
                                    </div>                                    
                                </div>
                                <div class="row col-lg-12 p-0" style="display: flex;">
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish5.jpg" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish6.jpg" width="100%" style="min-height: 250px;">
                                    </div>
                                    <div class="col-lg-4 p-1 card-div">
                                        <img src="img/theme/fish7.jpg" width="100%" style="min-height: 250px;">
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
.line {
    border-bottom: 1px solid #e9ecef;
    padding-bottom: 40px;
    margin-bottom:  40px;
}

.mid-line{
    border-bottom: 3px solid black;
    width: 40px;
    border-radius: 1em;
    margin-bottom: 30px;
}

.header-text{
    font-size: 25px;
    font-weight: 300;
    padding-bottom: 10px;
}

.card-div{
    width: 100%;
    /* height: 100%; */
    padding: 0px 30px 0px 30px;
}

.card-header-bus{
    color:#FFF; 
    font-weight: 300;
    padding: 60px 0 60px 0;
    display: flex;
    justify-content: center;
    background-color: #FFF;
}

.bg-white-gray{
    background-color: #f3f3f3;
}

.ul{
    display: block;
}
.ul > li{
    display: inline-block;
    position: relative;
    font-size: 15px;
    color: #666;
    padding-left: 10px;
    display: inline-block;
    width: 300px;
    vertical-align: top;
    margin: 10px 0;
}

.font-20{
    font-size: 20px;
}
.font-15{
    font-size: 15px;
}

.img-fish-fit{
    width: auto;
    height: 100%;
}
</style>
